import { colors } from "../../../styles/colors";

export const StageCircle = (status?: string) => ({
    border: `2px solid ${colors.circleBorder.border}`,
    borderRadius: "100%",
    width: "1.7rem",
    height: "1.7rem",
    lineHeight: "1.7rem",
    textAlign: "center",
    backgroundColor: status === "COMPLETED" ? colors.brand["secondary"] : "none",
    zIndex: 2,
    opacity: 0.8,
    borderColor: colors.brand["secondary"],
});

export const LabelGrid = () => ({
    textAlign: "center",
    textTransform: "uppercase",
    padding: "0.7rem 0 1rem 1rem"
})

export const StageLine = () => ({
    padding: "1.1rem 0.8rem 0 0.8rem"
});

export const NavLine = () => ({
    border: `1px dotted ${colors.circleBorder.oliveDrab}`,
    width: "4rem",
    height: 0,
    content: '""',
    zIndex: 1,
});

export const TopGrid = () => ({
    display: "flex",
    justifyContent: "center",
    textTransform: "uppercase",
    padding: "0 0.7rem 0.7rem 0.7rem"
});